import { createContext, useContext, useState, useEffect, useCallback } from "react";
import client from "@/api";
import { translate, LANGUAGES } from "@/i18n";

const AppContext = createContext(null);
export const useApp = () => useContext(AppContext);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [accessStatus, setAccessStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState(localStorage.getItem("lang") || "de");

  const t = useCallback((key, vars) => translate(lang, key, vars), [lang]);

  const changeLang = useCallback(async (code) => {
    setLang(code);
    localStorage.setItem("lang", code);
    document.documentElement.lang = code;
    try { await client.put("/auth/language", { language: code }); } catch (_) {}
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await client.get("/auth/me");
      setUser(data.user);
      setAccessStatus(data.access_status);
      if (data.user?.language_pref && !localStorage.getItem("lang")) {
        setLang(data.user.language_pref);
      }
    } catch (_) {
      setUser(null);
      setAccessStatus(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try { await client.post("/auth/logout"); } catch (_) {}
    setUser(null); setAccessStatus(null);
    window.location.href = "/";
  }, []);

  return (
    <AppContext.Provider value={{ user, setUser, accessStatus, setAccessStatus, loading, lang, changeLang, t, logout, checkAuth, LANGUAGES }}>
      {children}
    </AppContext.Provider>
  );
}
